import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Check } from 'lucide-react';
const stackItems = ['6 tomos especializados', '6 bonos incluidos', 'Plantillas aplicables', 'Materiales digitales organizados', 'Acceso inmediato', 'Pago único'];
export function ValueStack() {
  return <section className="py-8 bg-transparent relative overflow-hidden" data-id="element-237">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-orange-500/5 to-transparent pointer-events-none" data-id="element-238" />

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-239">
        <div className="text-center mb-16" data-id="element-240">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-241">
            Mucho más que un pack: una{' '}
            <span className="text-gradient" data-id="element-242">biblioteca profesional</span> lista
            para usar
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-243">
            Si tuvieras que crear, comprar u organizar todo esto por separado,
            invertirías mucho más tiempo y dinero.
          </p>
        </div>

        <div className="glass-card rounded-3xl p-8 md:p-12 border border-orange-500/20 shadow-[0_0_50px_rgba(168,85,247,0.15)]" data-id="element-244">
          <div className="flex flex-col gap-4" data-id="element-245">
            {stackItems.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-4 pb-4 border-b border-white/5 last:border-0 last:pb-0" data-id="element-246">
                <div className="w-8 h-8 rounded-full bg-orange-500/20 flex items-center justify-center shrink-0" data-id="element-247">
                  <Check className="w-5 h-5 text-orange-400" data-id="element-248" />
                </div>
                <span className="text-lg md:text-xl font-medium text-gray-200" data-id="element-249">
                  {item}
                </span>
              </motion.div>)}
          </div>

          <div className="mt-12 pt-8 border-t border-orange-500/20 text-center" data-id="element-250">
            <p className="text-2xl font-bold text-white" data-id="element-251">
              Hoy puedes acceder a todo en una sola compra.
            </p>
          </div>
        </div>
      </div>
    </section>;
}